/**
 * Portfolio / one chip per property — which slice of the dashboard is showing.
 *
 * Pills rather than a second underlined tab strip (DOP-609): directly under
 * the page's own tabs (Table, Charts, Needs review, History), a second row of
 * identical tabs read as more sections of the page rather than as a filter on
 * the one that is open. A filled chip says "this is the selection".
 *
 * Scrolls sideways rather than wrapping: a portfolio of twenty properties
 * would otherwise push the grid down by several rows.
 */

import React from "react";

import type { PageTab } from "../Dashboards/PageTabs";

export interface KpiPropertyChipsProps {
	options: readonly PageTab[];
	activeId: string;
	onSelect: (id: string) => void;
}

const KpiPropertyChips: React.FC<KpiPropertyChipsProps> = ({
	options,
	activeId,
	onSelect,
}) => (
	<div
		role="group"
		aria-label="KPI scope"
		className="flex min-w-0 items-center gap-2 overflow-x-auto"
	>
		{options.map((option) => {
			const active = option.id === activeId;
			return (
				<button
					key={option.id}
					type="button"
					aria-pressed={active}
					onClick={() => onSelect(option.id)}
					className={`inline-flex h-[30px] shrink-0 items-center whitespace-nowrap rounded-full border px-3 text-sm focus:outline-none focus:ring-1 focus:ring-[#008782] focus:ring-offset-1 ${
						active
							? "border-[#004C4B] bg-[#004C4B] font-semibold text-white"
							: "border-gray-200 bg-white text-[#3f4247] hover:border-gray-300 hover:bg-gray-50"
					}`}
				>
					{option.label}
				</button>
			);
		})}
	</div>
);

export default KpiPropertyChips;
